<template>
    <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :searchs="searchs" :operate="[]" :permission="permission"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "ServerConfig",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'serverConfig:add',
                    update: 'serverConfig:update',
                    delete: 'serverConfig:delete',
                    deleteBatch: 'serverConfig:deleteBatch'
                },
                url: {
                    get: '/serverConfig/listByCondition',
                    add: '/serverConfig/add',
                    update: '/serverConfig/update',
                    delete: '/serverConfig/delete/',
                    delete_batch: '/serverConfig/deleteBatch',
                },
                searchs: [{
                    name: 'publicIp',
                    placeholder: '公网IP',
                    type: 'input'
                }, {
                    name: 'innerIp',
                    placeholder: '内网IP',
                    type: 'input'
                }, {
                    name: 'isInner',
                    placeholder: '是否内网',
                    type: 'select',
                    selectValue:[
                        {
                            key: "1",
                            value: "是"
                        },
                        {
                            key: "0",
                            value: "否"
                        }
                    ]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                }, {
                    field: 'publicIp',
                    label: '公网IP',
                    show: true,
                    width: '',
                }, {
                    field: 'innerIp',
                    label: '内网IP',
                    show: true,
                    width: '',
                }, {
                    field: 'port',
                    label: '端口',
                    show: true,
                    width: '',
                }, {
                    field: 'username',
                    label: '用户名',
                    show: true,
                    width: '',
                }, {
                    field: 'password',
                    label: '密码',
                    show: true,
                    width: '',
                }, {
                    field: 'apiKey',
                    label: 'apiKey',
                    show: true,
                    width: '',
                },{
                    field: 'isInner',
                    label: '是否内网',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '是',
                                type: 'success'
                            },{
                                key: 0,
                                value: '否',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '80',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加服务器配置',
                    updateTitle: '修改服务器配置',
                    model: [{
                        field: 'publicIp',
                        label: '公网IP',
                        type: 'input',
                        placeholder: '公网IP',
                        rules:[{required: true, message: '请输入公网IP', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'innerIp',
                        label: '内网IP',
                        type: 'input',
                        placeholder: '内网IP',
                        rules:[{required: true, message: '请输入内网IP', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'port',
                        label: '端口',
                        type: 'input',
                        placeholder: '端口',
                        rules:[{required: true, message: '请输入端口', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'username',
                        label: '用户名',
                        type: 'input',
                        placeholder: '用户名',
                        rules:[{required: true, message: '请输入用户名', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'password',
                        label: '密码',
                        type: 'password',
                        placeholder: '密码',
                        rules:[{required: true, message: '请输入密码', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'apiKey',
                        label: 'apiKey',
                        type: 'input',
                        placeholder: 'apiKey',
                        rules:[{required: true, message: '请输入apiKey', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }, {
                        field: 'isInner',
                        label: '是否内网',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '是',
                        }, {
                            id: 0,
                            name: '否',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
